import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-text-output',
    templateUrl: './text-output.component.html',
    styleUrls: ['./text-output.component.less']
})
export class TextOutputComponent {
    @Input() label: any;
    @Input() labelBold: boolean;
    @Input() labelLight: boolean;
    @Input() tooltip: string;
}
